/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Alert API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseAlertEventMatchedProcessResponse,
  EventAlertCommonRequestBody,
  EventAlertDetailResponse,
  EventAlertHistoryResponse,
  EventAlertListResponse,
  EventAlertTopCountResponse,
  FilterWithOptionResponse,
  GetV9AlertEventDetailParams,
  GetV9AlertEventMatchedProcessParams,
  PostV9AlertEventHistoryParams,
  PostV9AlertEventListParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Event Alert Detail
 */
export const getV9AlertEventDetail = (
  params: MaybeRef<GetV9AlertEventDetailParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<EventAlertDetailResponse>(
    { url: `/api/v9/alert/event/detail`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV9AlertEventDetailQueryKey = (
  params?: MaybeRef<GetV9AlertEventDetailParams>,
) => {
  return ['api', 'v9', 'alert', 'event', 'detail', ...(params ? [params] : [])] as const;
};

export const getGetV9AlertEventDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertEventDetail>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertEventDetailParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertEventDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertEventDetailQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertEventDetail>>> = ({ signal }) =>
    getV9AlertEventDetail(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertEventDetail>>,
    TError,
    TData
  >;
};

export type GetV9AlertEventDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertEventDetail>>
>;
export type GetV9AlertEventDetailQueryError = ErrorType<unknown>;

/**
 * @summary Event Alert Detail
 */

export function useGetV9AlertEventDetail<
  TData = Awaited<ReturnType<typeof getV9AlertEventDetail>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertEventDetailParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertEventDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertEventDetailQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 이벤트 알람 필터
 */
export const getV9AlertEventFilter = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<FilterWithOptionResponse>(
    { url: `/api/v9/alert/event/filter`, method: 'GET', signal },
    options,
  );
};

export const getGetV9AlertEventFilterQueryKey = () => {
  return ['api', 'v9', 'alert', 'event', 'filter'] as const;
};

export const getGetV9AlertEventFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertEventFilter>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV9AlertEventFilter>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertEventFilterQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertEventFilter>>> = ({ signal }) =>
    getV9AlertEventFilter(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertEventFilter>>,
    TError,
    TData
  >;
};

export type GetV9AlertEventFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertEventFilter>>
>;
export type GetV9AlertEventFilterQueryError = ErrorType<unknown>;

/**
 * @summary 이벤트 알람 필터
 */

export function useGetV9AlertEventFilter<
  TData = Awaited<ReturnType<typeof getV9AlertEventFilter>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertEventFilter>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertEventFilterQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Event Alert Histroy
 */
export const postV9AlertEventHistory = (
  eventAlertCommonRequestBody: MaybeRef<EventAlertCommonRequestBody>,
  params: MaybeRef<PostV9AlertEventHistoryParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  eventAlertCommonRequestBody = unref(eventAlertCommonRequestBody);
  params = unref(params);

  return customAxiosInstance<EventAlertHistoryResponse>(
    {
      url: `/api/v9/alert/event/history`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: eventAlertCommonRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV9AlertEventHistoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertEventHistory>>,
    TError,
    { data: BodyType<EventAlertCommonRequestBody>; params: PostV9AlertEventHistoryParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertEventHistory>>,
  TError,
  { data: BodyType<EventAlertCommonRequestBody>; params: PostV9AlertEventHistoryParams },
  TContext
> => {
  const mutationKey = ['postV9AlertEventHistory'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertEventHistory>>,
    { data: BodyType<EventAlertCommonRequestBody>; params: PostV9AlertEventHistoryParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV9AlertEventHistory(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertEventHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertEventHistory>>
>;
export type PostV9AlertEventHistoryMutationBody = BodyType<EventAlertCommonRequestBody>;
export type PostV9AlertEventHistoryMutationError = ErrorType<unknown>;

/**
 * @summary Event Alert Histroy
 */
export const usePostV9AlertEventHistory = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertEventHistory>>,
      TError,
      { data: BodyType<EventAlertCommonRequestBody>; params: PostV9AlertEventHistoryParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertEventHistory>>,
  TError,
  { data: BodyType<EventAlertCommonRequestBody>; params: PostV9AlertEventHistoryParams },
  TContext
> => {
  const mutationOptions = getPostV9AlertEventHistoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Event Alert List
 */
export const postV9AlertEventList = (
  eventAlertCommonRequestBody: MaybeRef<EventAlertCommonRequestBody>,
  params?: MaybeRef<PostV9AlertEventListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  eventAlertCommonRequestBody = unref(eventAlertCommonRequestBody);
  params = unref(params);

  return customAxiosInstance<EventAlertListResponse>(
    {
      url: `/api/v9/alert/event/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: eventAlertCommonRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV9AlertEventListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertEventList>>,
    TError,
    { data: BodyType<EventAlertCommonRequestBody>; params?: PostV9AlertEventListParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertEventList>>,
  TError,
  { data: BodyType<EventAlertCommonRequestBody>; params?: PostV9AlertEventListParams },
  TContext
> => {
  const mutationKey = ['postV9AlertEventList'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertEventList>>,
    { data: BodyType<EventAlertCommonRequestBody>; params?: PostV9AlertEventListParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV9AlertEventList(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertEventListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertEventList>>
>;
export type PostV9AlertEventListMutationBody = BodyType<EventAlertCommonRequestBody>;
export type PostV9AlertEventListMutationError = ErrorType<unknown>;

/**
 * @summary Event Alert List
 */
export const usePostV9AlertEventList = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertEventList>>,
      TError,
      { data: BodyType<EventAlertCommonRequestBody>; params?: PostV9AlertEventListParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertEventList>>,
  TError,
  { data: BodyType<EventAlertCommonRequestBody>; params?: PostV9AlertEventListParams },
  TContext
> => {
  const mutationOptions = getPostV9AlertEventListMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Matched Process List
 */
export const getV9AlertEventMatchedProcess = (
  params: MaybeRef<GetV9AlertEventMatchedProcessParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseAlertEventMatchedProcessResponse>(
    { url: `/api/v9/alert/event/matched-process`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV9AlertEventMatchedProcessQueryKey = (
  params?: MaybeRef<GetV9AlertEventMatchedProcessParams>,
) => {
  return ['api', 'v9', 'alert', 'event', 'matched-process', ...(params ? [params] : [])] as const;
};

export const getGetV9AlertEventMatchedProcessQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertEventMatchedProcess>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertEventMatchedProcessParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertEventMatchedProcess>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertEventMatchedProcessQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertEventMatchedProcess>>> = ({
    signal,
  }) => getV9AlertEventMatchedProcess(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertEventMatchedProcess>>,
    TError,
    TData
  >;
};

export type GetV9AlertEventMatchedProcessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertEventMatchedProcess>>
>;
export type GetV9AlertEventMatchedProcessQueryError = ErrorType<unknown>;

/**
 * @summary Matched Process List
 */

export function useGetV9AlertEventMatchedProcess<
  TData = Awaited<ReturnType<typeof getV9AlertEventMatchedProcess>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertEventMatchedProcessParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertEventMatchedProcess>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertEventMatchedProcessQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Top 100 Alert
 */
export const postV9AlertEventTop = (
  eventAlertCommonRequestBody: MaybeRef<EventAlertCommonRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  eventAlertCommonRequestBody = unref(eventAlertCommonRequestBody);

  return customAxiosInstance<EventAlertTopCountResponse>(
    {
      url: `/api/v9/alert/event/top`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: eventAlertCommonRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV9AlertEventTopMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertEventTop>>,
    TError,
    { data: BodyType<EventAlertCommonRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertEventTop>>,
  TError,
  { data: BodyType<EventAlertCommonRequestBody> },
  TContext
> => {
  const mutationKey = ['postV9AlertEventTop'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertEventTop>>,
    { data: BodyType<EventAlertCommonRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV9AlertEventTop(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertEventTopMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertEventTop>>
>;
export type PostV9AlertEventTopMutationBody = BodyType<EventAlertCommonRequestBody>;
export type PostV9AlertEventTopMutationError = ErrorType<unknown>;

/**
 * @summary Top 100 Alert
 */
export const usePostV9AlertEventTop = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertEventTop>>,
      TError,
      { data: BodyType<EventAlertCommonRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertEventTop>>,
  TError,
  { data: BodyType<EventAlertCommonRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV9AlertEventTopMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
